// extracted by mini-css-extract-plugin
module.exports = {"root":"EntryRow_root__2HvWk","bottom":"EntryRow_bottom__24EE8","link":"EntryRow_link__2fWq0"};